import { render, staticRenderFns } from "./part-4-global.vue?vue&type=template&id=4a22954f&"
import script from "./part-4-global.vue?vue&type=script&lang=js&"
export * from "./part-4-global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports